'use client';

// Small shared pieces for the standalone auth screens.

import React from "react";

export const AField = ({ label, children, hint }) => (
  <label className="block">
    <span className="mb-1 block text-xs font-medium uppercase tracking-wider text-zinc-500">{label}</span>
    {children}
    {hint && <span className="mt-1 block text-xs text-zinc-400">{hint}</span>}
  </label>
);

export const AInput = ({ className = "", ...props }) => (
  <input
    {...props}
    className={`w-full rounded-lg border border-zinc-300 px-3 py-3 text-sm outline-none transition-colors focus:border-zinc-900 ${className}`}
  />
);

export const AError = ({ children, testId = "auth-error" }) =>
  children ? (
    <div data-testid={testId} className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
      {children}
    </div>
  ) : null;

export const ABtn = ({ children, busy, className = "", ...props }) => (
  <button
    {...props}
    disabled={busy || props.disabled}
    className={`inline-flex min-h-[48px] w-full items-center justify-center rounded-lg bg-zinc-900 px-4 font-medium text-white transition-colors hover:bg-zinc-700 disabled:opacity-50 ${className}`}
  >
    {busy ? "Please wait…" : children}
  </button>
);

export const ALink = ({ children, ...props }) => (
  <button {...props} type="button" className="text-sm font-medium text-zinc-700 underline underline-offset-4 hover:text-zinc-900">
    {children}
  </button>
);

// Shown only while Twilio is in test mode (no real SMS goes out).
export const DevCodeHint = ({ code }) =>
  code ? (
    <div data-testid="otp-dev-hint" className="rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900">
      <strong>Test mode</strong> — no real SMS was sent. Your code is{" "}
      <strong className="font-mono">{code}</strong>.
    </div>
  ) : null;

export const StepTag = ({ step, total }) => (
  <div className="text-xs font-medium uppercase tracking-wider text-zinc-400">
    Step {step} of {total}
  </div>
);
